import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
  padding: 80px 2.25rem;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};

  @media (min-width: 768px) {
    flex-direction: row;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  @media (min-width: 992px) {
    padding: 100px 5.5rem;
    gap: 64px;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }

  & > div:first-of-type {
    flex: 1;
  }

  & > div:last-of-type {
    flex: 2;
  }
`

export const Title = styled.h1`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`

export const BodyContainer = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ImagesContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  margin-top: 40px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const Image = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  max-width: unset;
  object-fit: contain;
  border-radius: 8px;

  & > :first-child {
    max-width: unset !important;
  }
`
